module.exports = __webpack_public_path__ + "img/cancel-circle.4076aa0c.svg";